import {
  SET_CLAIM_COUNT_TASK,
  SET_LAYOUT,
  SET_LOADING,
  SET_PAGE_NAME_LAYOUT,
  SET_ORDER_TASK,
  SET_TOS_TASK,
  SET_LIST_TOS_TASK,
} from "./actionType";
const initState = {
  page: "",
  isActiveSidebar: false,
  isActiveSidebarSm: true,
  isLoading: false,
  isHide: true,
  ClaimCountTask: {},
  orderTask: {},
  tosTask: {},
  listTosTask: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case SET_LAYOUT: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case SET_CLAIM_COUNT_TASK: {
      return {
        ...state,
        ClaimCountTask: {
          ...action.payload,
        },
      };
    }
    case SET_PAGE_NAME_LAYOUT: {
      return {
        ...state,
        page: action.payload,
      };
    }
    case SET_ORDER_TASK: {
      return {
        ...state,
        orderTask: { ...action.payload },
      };
    }
    case SET_TOS_TASK: {
      return {
        ...state,
        tosTask: {
          ...action.payload,
        },
      };
    }
    case SET_LIST_TOS_TASK: {
      return {
        ...state,
        listTosTask: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
}
